module.exports = __webpack_public_path__ + "img/thumb_34.8869ad79.jpg";